module.exports = __webpack_public_path__ + "static/media/GelBoxBufferOpen.5b1e4cf0.svg";